var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.406a.795.795 0 01-.804-.781v-2.5c0-.43.362-.781.804-.781.442 0 .804.351.804.781v2.5c0 .43-.362.781-.804.781zm9-5.781v7.5C21 21.16 20.136 22 19.071 22H4.93C3.864 22 3 21.16 3 20.125v-7.5c0-1.035.864-1.875 1.929-1.875h.642v-2.5c0-3.453 2.893-6.262 6.45-6.25 3.55.012 6.408 2.856 6.408 6.309v2.441h.642c1.065 0 1.929.84 1.929 1.875zM6.857 10.75h10.286v-2.5c0-2.758-2.306-5-5.143-5-2.837 0-5.143 2.242-5.143 5v2.5zm12.857 9.375v-7.5a.636.636 0 00-.643-.625H4.93a.636.636 0 00-.643.625v7.5c0 .344.289.625.643.625h14.14a.636.636 0 00.643-.625z",
    fill: "var(--color-secondary)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocker);
export default __webpack_public_path__ + "static/media/locker.9239b2e89ecd529c766a8663fdc997da.svg";
export { ForwardRef as ReactComponent };